import { MarppleShopAdminSolutionsTypeS } from '@services/MarppleShopAdmin/features/Solutions/outbound/share.ts';
import axios, { AxiosResponse } from 'axios';
import { makeApiUrl } from '@services/MarppleShop/shared/util';
import { FundingListFetchOptionValidator, FundingListService } from '@services/MarppleShop/features/Funding';
import { z } from 'zod';

export const getFundingList = async (
  store_id: number,
  fetch_options: z.infer<typeof FundingListFetchOptionValidator>,
) => {
  const { data: res } = await axios.post<
    MarppleShopAdminSolutionsTypeS.SolutionsFetchOption,
    AxiosResponse<{
      data: Awaited<ReturnType<InstanceType<typeof FundingListService>['getFundingList']>>;
    }>
  >(
    makeApiUrl('/@api/:store_id/fundings', {
      store_id,
    }),
    fetch_options,
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  return res.data;
};
